import React, { useState, useEffect, useRef } from 'react';
import api from './api';
import Layout from './components/Layout';
import Funcionario from './pages/Funcionario';
import Financeiro from './pages/Financeiro';
import Gestor from './pages/Gestor';
import Estoque from './pages/Estoque';
import Fechamento from './pages/Fechamento';
import Orcamento from './pages/Orcamento';
import Agenda from './pages/Agenda';
import Tickets from './pages/Tickets';
import Chat from './pages/Chat';
import Relatorios from './pages/Relatorios';
import Cofre from './pages/Cofre';
import Contratos from './pages/Contratos';
import Monitoramento from './pages/Monitoramento'; // NOVO v42

const todasAbas = {
  func: [
    { key: 'reembolso', label: 'Reembolso' },
  ],
  fin: [
    { key: 'pagamentos', label: 'Financeiro' },
  ],
  ges: [
    { key: 'config', label: 'Configurações' },
  ],
  est: [
    { key: 'estoque', label: 'Estoque' },
  ],
  fec: [
    { key: 'fechamento', label: 'Fechamento' },
  ],
  orc: [
    { key: 'orcamentos', label: 'Orçamentos' },
  ],
  age: [
    { key: 'agenda', label: 'Agenda' },
  ],
  tkt: [
    { key: 'tickets', label: 'Tickets' },
  ],
  cht: [
    { key: 'chat', label: 'Chat' },
  ],
  cof: [
    { key: 'cofre', label: 'Cofre' },
  ],
  ctr: [
    { key: 'contratos', label: 'Contratos' },
  ],
  rel: [
    { key: 'relatorios', label: 'Relatórios' },
  ],
  mon: [
    { key: 'monitoramento', label: 'Monitoramento' }, // NOVO v42
  ],
};

const abaInicial = {
  func: 'reembolso',
  fin: 'pagamentos',
  ges: 'config',
  est: 'estoque',
  fec: 'fechamento',
  orc: 'orcamentos',
  age: 'agenda',
  tkt: 'tickets',
  cht: 'chat',
  cof: 'cofre',
  rel: 'relatorios',
  ctr: 'contratos',
  mon: 'monitoramento', // NOVO v42
};

function getAbas(perfis, modulos = []) {
  const modulosControlados = ['tkt', 'cht', 'ctr', 'mon'];
  const vistas = new Set();
  const abas = [];
  (perfis || []).forEach(p => {
    if (modulosControlados.includes(p) && !modulos.includes(p)) return;
    (todasAbas[p] || []).forEach(aba => {
      if (!vistas.has(aba.key)) {
        vistas.add(aba.key);
        abas.push(aba);
      }
    });
  });
  return abas;
}

function getAbaInicial(perfis) {
  if (!perfis || perfis.length === 0) return '';
  return abaInicial[perfis[0]] || '';
}

function Toast({ msg, tipo }) {
  if (!msg) return null;
  const bg = tipo === 'success' ? '#27ae60' : tipo === 'error' ? '#e74c3c' : '#1A2233';
  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24,
      background: bg, color: 'white',
      padding: '14px 20px', borderRadius: 8,
      fontSize: 14, fontWeight: 500,
      boxShadow: '0 8px 32px rgba(0,0,0,0.14)',
      zIndex: 9999
    }}>
      {msg}
    </div>
  );
}

// ─── Card de Alertas do Cofre ─────────────────────────────────────────────────
function CardAlertasCofre({ alertas, onFechar, onIrCofre }) {
  const [lidos, setLidos] = useState([]);

  async function marcarLido(id) {
    try { await api.post(`/cofre/alertas/${id}/ler`); } catch {}
    setLidos(p => [...p, id]);
  }

  async function marcarTodos() {
    try { await api.post('/cofre/alertas/ler-todos'); } catch {}
    onFechar();
  }

  const visiveis = alertas.filter(a => !lidos.includes(a.id));

  if (visiveis.length === 0) { onFechar(); return null; }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(26,34,51,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 8000, padding: 16,
    }}>
      <div style={{
        background: '#fff', borderRadius: 14, padding: 28, width: '100%', maxWidth: 520,
        boxShadow: '0 8px 40px rgba(0,0,0,0.22)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div>
            <h2 style={{ margin: 0, color: '#1A2233', fontSize: 18 }}>🔐 Senhas Expirando</h2>
            <p style={{ margin: '4px 0 0', fontSize: 13, color: '#888' }}>
              {visiveis.length} senha(s) precisam de atenção
            </p>
          </div>
          <button onClick={onFechar}
            style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }}>×</button>
        </div>

        <div style={{ maxHeight: 320, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 10 }}>
          {visiveis.map(a => (
            <div key={a.id} style={{
              background: '#fff8f5', border: '1px solid #f5cbb0',
              borderLeft: '4px solid #D85A30', borderRadius: 8, padding: '12px 14px',
              display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10,
            }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 13, color: '#1A2233', marginBottom: 4 }}>{a.titulo}</div>
                <div style={{ fontSize: 12, color: '#D85A30' }}>{a.mensagem}</div>
              </div>
              <button onClick={() => marcarLido(a.id)}
                style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 18, padding: 2, flexShrink: 0 }}
                title="Dispensar">✕</button>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button onClick={marcarTodos}
            style={{ flex: 1, padding: '10px', border: '1px solid #d4dde8', borderRadius: 8, background: '#fff', cursor: 'pointer', fontSize: 13, color: '#555' }}>
            Dispensar todos
          </button>
          <button onClick={() => { onFechar(); onIrCofre(); }}
            style={{ flex: 1, padding: '10px', background: '#D85A30', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
            🔐 Ir ao Cofre
          </button>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [usuario, setUsuario] = useState(null);
  const [aba, setAba] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [toast, setToast] = useState({ msg: '', tipo: '' });
  const [trocarSenha, setTrocarSenha] = useState(false);
  const [senhaAntiga, setSenhaAntiga] = useState('');
  const [senhaNova, setSenhaNova] = useState('');
  const [senhaConfirm, setSenhaConfirm] = useState('');
  const [erroTroca, setErroTroca] = useState('');
  const [salvandoSenha, setSalvandoSenha] = useState(false);
  const [mfaPendente, setMfaPendente] = useState(null);
  const [mfaCodigo, setMfaCodigo] = useState('');
  const [mfaErro, setMfaErro] = useState('');
  const [mfaReenviando, setMfaReenviando] = useState(false);
  const [mfaCountdown, setMfaCountdown] = useState(0);
  const [mfaConfiar, setMfaConfiar] = useState(false);
  const [cofreAlertas, setCofreAlertas] = useState([]);
  const [mostrarCardAlertas, setMostrarCardAlertas] = useState(false);
  const [pushStatus, setPushStatus] = useState('indefinido'); // indefinido | ativando | ativado | negado | indisponivel

  useEffect(() => {
    const init = async () => {
      try {
        const u = localStorage.getItem('usuario');
        const token = localStorage.getItem('token');
        if (u && token) {
          const parsed = JSON.parse(u);
          setUsuario(parsed);
          setAba(getAbaInicial(parsed.perfis || [parsed.perfil]));
          try {
            const res = await api.get('/usuarios');
            const atualizado = res.data.find(x => x.id === parsed.id);
            if (atualizado) {
              const perfisAtualizados = atualizado.perfis || [atualizado.perfil];
              // Preserva modulos do token/localStorage — o endpoint /usuarios não retorna modulos
              const modulosAtualizados = atualizado.modulos || parsed.modulos || [];
              const uAtualizado = { ...parsed, perfis: perfisAtualizados, perfil: perfisAtualizados[0], modulos: modulosAtualizados };
              localStorage.setItem('usuario', JSON.stringify(uAtualizado));
              setUsuario(uAtualizado);
              setAba(prev => {
                // Passa modulosAtualizados para que módulos controlados (ctr, tkt, cht) apareçam corretamente
                const abasDisponiveis = getAbas(perfisAtualizados, modulosAtualizados).map(a => a.key);
                if (abasDisponiveis.includes(prev)) return prev;
                return getAbaInicial(perfisAtualizados);
              });
            }
          } catch {}
        }
      } catch {
        localStorage.removeItem('usuario');
      }
    };
    init();
  }, []);

  const showToast = (msg, tipo = '') => {
    setToast({ msg, tipo });
    setTimeout(() => setToast({ msg: '', tipo: '' }), 3000);
  };

  // Verifica senhas expirando — chamada após qualquer login bem-sucedido
  const verificarExpiracao = async () => {
    try {
      const perfisUsuario = JSON.parse(localStorage.getItem('usuario') || '{}').perfis || [];
      const temCofre = perfisUsuario.includes('ges') || perfisUsuario.includes('cof');
      if (!temCofre) return;
      await api.post('/cofre/verificar-expiracao');
      const { data } = await api.get('/cofre/alertas');
      if (data.alertas?.length > 0) {
        setCofreAlertas(data.alertas);
        setMostrarCardAlertas(true);
      }
    } catch {}
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      const trustedToken = localStorage.getItem('mfa_trusted_' + email);
      const res = await api.post('/auth/login', { email, senha, trusted_token: trustedToken || undefined });

      if (res.data.mfa_required) {
        setMfaPendente({ user_id: res.data.user_id, tenant_id: res.data.tenant_id, email_destino: res.data.email_destino });
        setCarregando(false);
        return;
      }

      if (res.data.trocar_senha) {
        const u = { email, perfil: 'ges', perfis: ['ges'], nome: '', id: res.data.user_id, tenant_id: res.data.tenant_id };
        setTrocarSenha(true);
        setUsuario(u);
        setCarregando(false);
        return;
      }

      const tokenPayload2 = JSON.parse(atob(res.data.token.split('.')[1]));
      const u = res.data.usuario || { id: tokenPayload2.id, email, perfil: res.data.perfil, perfis: res.data.perfis || [res.data.perfil], nome: res.data.nome, tenant_id: tokenPayload2.tenant_id, modulos: res.data.modulos || [] };
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('usuario', JSON.stringify(u));
      setUsuario(u);
      setAba(getAbaInicial(u.perfis || [u.perfil]));
      setTimeout(verificarExpiracao, 1500); // pequeno delay para garantir token salvo
    } catch {
      setErro('Email ou senha inválidos.');
    } finally {
      setCarregando(false);
    }
  };

  const handleMfaVerify = async () => {
    setMfaErro('');
    try {
      const res = await api.post('/auth/mfa/verify', { user_id: mfaPendente.user_id, code: mfaCodigo, confiar_dispositivo: mfaConfiar });
      const tokenPayload1 = JSON.parse(atob(res.data.token.split('.')[1]));
      const u = res.data.usuario || { id: tokenPayload1.id, email, perfil: res.data.perfil, perfis: res.data.perfis || [res.data.perfil], nome: res.data.nome, tenant_id: tokenPayload1.tenant_id, modulos: res.data.modulos || [] };
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('usuario', JSON.stringify(u));
      if (res.data.trusted_token) {
        localStorage.setItem('mfa_trusted_' + email, res.data.trusted_token);
      }
      setMfaPendente(null);
      setMfaCodigo('');
      setMfaConfiar(false);
      setUsuario(u);
      setAba(getAbaInicial(u.perfis || [u.perfil]));
      setTimeout(verificarExpiracao, 1500);
    } catch (err) {
      setMfaErro(err?.response?.data?.erro || 'Código inválido ou expirado.');
    }
  };

  const handleMfaReenviar = async () => {
    if (mfaCountdown > 0) return;
    setMfaReenviando(true);
    try {
      await api.post('/auth/mfa/resend', { user_id: mfaPendente.user_id });
      setMfaCountdown(60);
      const interval = setInterval(() => setMfaCountdown(c => { if (c <= 1) { clearInterval(interval); return 0; } return c - 1; }), 1000);
    } catch {}
    setMfaReenviando(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setUsuario(null);
    setEmail('');
    setSenha('');
  };

  const criteriosSenhaTroca = [
    { label: 'Mínimo 8 caracteres', test: s => s.length >= 8 },
    { label: 'Letra maiúscula (A-Z)', test: s => /[A-Z]/.test(s) },
    { label: 'Letra minúscula (a-z)', test: s => /[a-z]/.test(s) },
    { label: 'Número (0-9)', test: s => /[0-9]/.test(s) },
    { label: 'Caractere especial (!@#$...)', test: s => /[^a-zA-Z0-9]/.test(s) },
  ];
  const senhaForteTroca = criteriosSenhaTroca.every(c => c.test(senhaNova));
  const aprovadosTroca = criteriosSenhaTroca.filter(c => c.test(senhaNova)).length;
  const coresTroca = ['#d4dde8', '#e74c3c', '#e67e22', '#f1c40f', '#2ecc71', '#27ae60'];
  const corTroca = senhaNova ? coresTroca[aprovadosTroca] : coresTroca[0];

  const handleTrocarSenha = async (e) => {
    e.preventDefault();
    setErroTroca('');
    if (!senhaForteTroca) { setErroTroca('A senha não atende aos requisitos de segurança.'); return; }
    if (senhaNova !== senhaConfirm) { setErroTroca('As senhas não coincidem.'); return; }
    setSalvandoSenha(true);
    try {
      await api.post('/auth/trocar-senha', {
        email: usuario.email,
        senha_antiga: senhaAntiga,
        senha_nova: senhaNova,
      });
      setTrocarSenha(false);
      setAba(getAbaInicial(usuario.perfis || [usuario.perfil]));
      showToast('Senha alterada com sucesso!', 'success');
    } catch (err) {
      setErroTroca(err?.response?.data?.erro || 'Erro ao trocar senha.');
    } finally {
      setSalvandoSenha(false);
    }
  };

  const perfis = usuario ? (usuario.perfis || [usuario.perfil]) : [];
  const modulos = usuario ? (usuario.modulos || []) : [];
  const temChatOuTickets = (perfis.includes('cht') && modulos.includes('cht')) || (perfis.includes('tkt') && modulos.includes('tkt'));

  // ─── Polling global de alertas sonoros (funciona em qualquer aba) ─────────────
  const conversasAntRef    = useRef(null);
  const ticketsAbertosRef  = useRef(null);

  // ── Helpers de som e supressão ────────────────────────────────────────────
  function somEstaAtivo() {
    if (window.__somAlertasAtivo !== undefined) return window.__somAlertasAtivo;
    return localStorage.getItem('som_alertas_ativo') !== 'false';
  }

  function deveSuprimirSom(conversaId) {
    return window.__chatConversaAtiva != null &&
           window.__chatConversaAtiva === conversaId;
  }

  function falar(frase) {
    try {
      if (!window.speechSynthesis || !somEstaAtivo()) return;
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(frase);
      u.lang  = 'pt-BR';
      u.rate  = 1.00;
      u.pitch = 1.05;
      const vozPt = window.speechSynthesis.getVoices().find(v => v.lang.startsWith('pt'));
      if (vozPt) u.voice = vozPt;
      window.speechSynthesis.speak(u);
    } catch {}
  }

  // ─── Notificações push do sistema operacional (independente do aviso sonoro) ──
  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
  }

  async function ativarNotificacoesPush() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
      setPushStatus('indisponivel');
      showToast('Este navegador não suporta notificações.', 'error');
      return;
    }

    setPushStatus('ativando');
    try {
      const permissao = await Notification.requestPermission();
      if (permissao !== 'granted') {
        setPushStatus('negado');
        showToast('Permissão de notificação negada.', 'error');
        return;
      }

      const registration = await navigator.serviceWorker.register('/sw.js');
      const { data } = await api.get('/push/vapid-public-key');

      let subscription = await registration.pushManager.getSubscription();
      if (!subscription) {
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(data.publicKey),
        });
      }

      await api.post('/push/subscribe', subscription.toJSON());

      setPushStatus('ativado');
      localStorage.setItem('push_ativado', 'true');
      showToast('Notificações ativadas neste dispositivo!', 'success');
    } catch (err) {
      setPushStatus('indefinido');
      showToast('Não foi possível ativar as notificações.', 'error');
    }
  }

  // Verifica status atual ao carregar (sem forçar pedido de permissão)
  useEffect(() => {
    if (!usuario) return;
    if (!('Notification' in window)) { setPushStatus('indisponivel'); return; }
    if (Notification.permission === 'denied') { setPushStatus('negado'); return; }
    if (Notification.permission === 'granted' && localStorage.getItem('push_ativado') === 'true') {
      setPushStatus('ativado');
    }
  }, [usuario]);

  useEffect(() => {
    if (!usuario) return;
    const temChat    = perfis.includes('cht') && modulos.includes('cht');
    const temTickets = perfis.includes('tkt') && modulos.includes('tkt');
    if (!temChat && !temTickets) return;

    // Limpa estado global ao montar/trocar de usuário
    window.__chatConversaAtiva  = null;
    window.__somAlertasAtivo    = undefined;
    window.__chatNovasMensagens = {};

    // ── Polling do Chat (4s) ──
    let chatInterval = null;
    if (temChat) {
      const pollChat = async () => {
        try {
          const r = await api.get('/whatsapp/conversas');
          const novas = r.data;

          if (conversasAntRef.current !== null) {
            const ant    = conversasAntRef.current;
            const idsAnt = new Set(ant.map(c => c.id));
            const mapAnt = new Map(ant.map(c => [c.id, c.ultima_mensagem_em]));

            // 1. Novas conversas na fila — nunca suprime (técnico precisa saber)
            const novasNaFila = novas.filter(c => !idsAnt.has(c.id) && c.status === 'aguardando');
            if (novasNaFila.length > 0) {
              falar('Atenção, novo chat');
            }

            // 2. Mensagens novas em conversas existentes
            const comMensagemNova = novas.filter(c => {
              const antEm = mapAnt.get(c.id);
              return antEm && c.ultima_mensagem_em && c.ultima_mensagem_em > antEm;
            });

            if (comMensagemNova.length > 0) {
              const novasMap = { ...(window.__chatNovasMensagens || {}) };
              comMensagemNova.forEach(c => { novasMap[c.id] = true; });
              if (window.__chatConversaAtiva) delete novasMap[window.__chatConversaAtiva];
              window.__chatNovasMensagens = novasMap;

              const meusId = usuario?.id;
              const paraNotificar = comMensagemNova.filter(c =>
                !deveSuprimirSom(c.id) &&
                (c.atendente_id === meusId || c.atendente_id == null || c.status === 'aguardando')
              );
              if (paraNotificar.length > 0) {
                falar('Nova mensagem recebida');
              }
            }
          }

          conversasAntRef.current = novas;
        } catch {}
      };
      pollChat();
      chatInterval = setInterval(pollChat, 4000);
    }

    // ── Polling de Tickets (30s) ──
    let ticketInterval = null;
    if (temTickets) {
      const pollTickets = async () => {
        try {
          const dash = await api.get('/tickets/dashboard');
          const qtdAbertos = dash.data?.aberto || 0;
          if (ticketsAbertosRef.current !== null && qtdAbertos > ticketsAbertosRef.current) {
            falar('Atenção, novo ticket');
          }
          ticketsAbertosRef.current = qtdAbertos;
        } catch {}
      };
      pollTickets();
      ticketInterval = setInterval(pollTickets, 30000);
    }

    return () => {
      clearInterval(chatInterval);
      clearInterval(ticketInterval);
      window.__chatConversaAtiva  = null;
      window.__chatNovasMensagens = {};
    };
  }, [usuario]); // eslint-disable-line

  // Injeta badge de alertas na aba do Cofre
  const abasSemBadge = getAbas(perfis, modulos);
  const abas = abasSemBadge.map(a => {
    if (a.key === 'cofre' && cofreAlertas.length > 0) {
      return { ...a, badge: cofreAlertas.length };
    }
    return a;
  });

  if (trocarSenha) return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#1A2233',
    }}>
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'radial-gradient(ellipse at 70% 20%, rgba(216,90,48,0.18) 0%, transparent 60%)', pointerEvents: 'none' }} />
      <div style={{
        background: 'white', borderRadius: 20, padding: '40px 28px',
        width: '100%', maxWidth: 420, margin: '0 16px',
        boxShadow: '0 24px 64px rgba(0,0,0,0.35)', boxSizing: 'border-box', position: 'relative', zIndex: 1,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>🔐</div>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#1A2233' }}>Redefina sua senha</div>
          <div style={{ fontSize: 13, color: '#8896AD', marginTop: 6 }}>Por segurança, crie uma nova senha para continuar.</div>
        </div>

        {erroTroca && <p style={{ color: '#e74c3c', textAlign: 'center', marginBottom: 12, fontSize: 14 }}>{erroTroca}</p>}

        <form onSubmit={handleTrocarSenha}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: '#6b7a8d', textTransform: 'uppercase', letterSpacing: 0.8, display: 'block', marginBottom: 6 }}>Senha atual</label>
            <input type="password" value={senhaAntiga} onChange={e => setSenhaAntiga(e.target.value)} placeholder="••••••••" required
              style={{ width: '100%', padding: '12px 14px', border: '1.5px solid #d4dde8', borderRadius: 8, fontSize: 15, boxSizing: 'border-box', outline: 'none' }}
              onFocus={e => e.target.style.borderColor = '#D85A30'} onBlur={e => e.target.style.borderColor = '#d4dde8'} />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: '#6b7a8d', textTransform: 'uppercase', letterSpacing: 0.8, display: 'block', marginBottom: 6 }}>Nova senha</label>
            <input type="password" value={senhaNova} onChange={e => setSenhaNova(e.target.value)} placeholder="••••••••" required
              style={{ width: '100%', padding: '12px 14px', border: '1.5px solid #d4dde8', borderRadius: 8, fontSize: 15, boxSizing: 'border-box', outline: 'none' }}
              onFocus={e => e.target.style.borderColor = '#D85A30'} onBlur={e => e.target.style.borderColor = '#d4dde8'} />

            {senhaNova.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <div style={{ display: 'flex', gap: 4, marginBottom: 8 }}>
                  {[1,2,3,4,5].map(i => (
                    <div key={i} style={{ flex: 1, height: 4, borderRadius: 2, background: i <= aprovadosTroca ? corTroca : '#d4dde8', transition: 'background 0.3s' }} />
                  ))}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  {criteriosSenhaTroca.map(c => (
                    <div key={c.label} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: c.test(senhaNova) ? '#27ae60' : '#6b7a8d' }}>
                      <span>{c.test(senhaNova) ? '✓' : '○'}</span>{c.label}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: '#6b7a8d', textTransform: 'uppercase', letterSpacing: 0.8, display: 'block', marginBottom: 6 }}>Confirmar nova senha</label>
            <input type="password" value={senhaConfirm} onChange={e => setSenhaConfirm(e.target.value)} placeholder="••••••••" required
              style={{ width: '100%', padding: '12px 14px', border: '1.5px solid #d4dde8', borderRadius: 8, fontSize: 15, boxSizing: 'border-box', outline: 'none' }}
              onFocus={e => e.target.style.borderColor = '#D85A30'} onBlur={e => e.target.style.borderColor = '#d4dde8'} />
          </div>

          <button type="submit" disabled={salvandoSenha} style={{
            width: '100%', padding: 14,
            background: salvandoSenha ? '#B84A24' : '#D85A30',
            color: 'white', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700,
            cursor: salvandoSenha ? 'not-allowed' : 'pointer', marginTop: 8,
          }}>
            {salvandoSenha ? 'Salvando...' : 'Salvar nova senha'}
          </button>
        </form>
      </div>
    </div>
  );

  // ── Tela MFA ──────────────────────────────────────────────────────────────
  if (mfaPendente) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1A2233' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '40px 28px', width: '100%', maxWidth: 420, margin: '0 16px', boxShadow: '0 24px 64px rgba(0,0,0,0.35)', boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>✉️</div>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#1A2233', marginBottom: 8 }}>Verificação de segurança</div>
          <div style={{ fontSize: 13, color: '#6b7a8d', lineHeight: 1.6 }}>
            Enviamos um código de 6 dígitos para<br />
            <strong style={{ color: '#1A2233' }}>{mfaPendente.email_destino}</strong>
          </div>
          <div style={{ fontSize: 12, color: '#6b7a8d', marginTop: 4 }}>Expira em 10 minutos</div>
        </div>

        {mfaErro && <p style={{ color: '#e74c3c', textAlign: 'center', marginBottom: 12, fontSize: 14 }}>{mfaErro}</p>}

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 12, fontWeight: 700, color: '#6b7a8d', textTransform: 'uppercase', letterSpacing: 0.8, display: 'block', marginBottom: 8 }}>Código de verificação</label>
          <input
            type="text" inputMode="numeric" maxLength={6}
            value={mfaCodigo} onChange={e => setMfaCodigo(e.target.value.replace(/\D/g, ''))}
            placeholder="000000" autoFocus
            style={{ width: '100%', padding: '14px', border: '2px solid #d4dde8', borderRadius: 10, fontSize: 28, fontWeight: 700, textAlign: 'center', letterSpacing: 10, boxSizing: 'border-box', outline: 'none', fontFamily: 'monospace', color: '#1A2233' }}
            onKeyDown={e => e.key === 'Enter' && mfaCodigo.length === 6 && handleMfaVerify()}
          />
        </div>

        <button onClick={handleMfaVerify} disabled={mfaCodigo.length < 6} style={{ width: '100%', padding: 14, background: mfaCodigo.length < 6 ? '#d4dde8' : '#D85A30', color: mfaCodigo.length < 6 ? '#6b7a8d' : 'white', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: mfaCodigo.length < 6 ? 'not-allowed' : 'pointer', marginBottom: 16 }}>
          Verificar código
        </button>

        <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', padding: '12px 0', borderTop: '1px solid #f0f3f7', borderBottom: '1px solid #f0f3f7', marginBottom: 4 }}>
          <div onClick={() => setMfaConfiar(v => !v)} style={{
            width: 42, height: 24, borderRadius: 12, flexShrink: 0,
            background: mfaConfiar ? '#D85A30' : '#d4dde8',
            position: 'relative', transition: 'background .2s', cursor: 'pointer',
          }}>
            <span style={{ position: 'absolute', top: 3, left: mfaConfiar ? 20 : 3, width: 18, height: 18, borderRadius: '50%', background: '#fff', transition: 'left .2s', display: 'block', boxShadow: '0 1px 3px rgba(0,0,0,.2)' }} />
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#1A2233' }}>Confiar neste dispositivo</div>
            <div style={{ fontSize: 11, color: '#6b7a8d', marginTop: 2 }}>Não pedir código por 30 dias neste navegador</div>
          </div>
        </label>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 16, fontSize: 13, marginTop: 8 }}>
          <button onClick={handleMfaReenviar} disabled={mfaCountdown > 0 || mfaReenviando} style={{ background: 'none', border: 'none', color: mfaCountdown > 0 ? '#6b7a8d' : '#D85A30', cursor: mfaCountdown > 0 ? 'default' : 'pointer', textDecoration: 'underline', fontSize: 13, padding: 0 }}>
            {mfaCountdown > 0 ? `Reenviar em ${mfaCountdown}s` : 'Reenviar código'}
          </button>
          <span style={{ color: '#d4dde8' }}>·</span>
          <button onClick={() => { setMfaPendente(null); setMfaCodigo(''); setMfaErro(''); setMfaConfiar(false); }} style={{ background: 'none', border: 'none', color: '#6b7a8d', cursor: 'pointer', fontSize: 13, padding: 0 }}>
            Voltar
          </button>
        </div>
      </div>
    </div>
  );

  if (!usuario) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1A2233' }}>
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'radial-gradient(ellipse at 70% 20%, rgba(216,90,48,0.18) 0%, transparent 60%)', pointerEvents: 'none' }} />
      <div style={{ background: 'white', borderRadius: 20, padding: '40px 28px', width: '100%', maxWidth: 420, margin: '0 16px', boxShadow: '0 24px 64px rgba(0,0,0,0.35)', boxSizing: 'border-box', position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo.png" alt="Sobraa" style={{ height: 90, objectFit: 'contain', marginBottom: 16 }} />
          <div style={{ fontSize: 13, fontWeight: 700, color: '#8896AD', letterSpacing: 1.5, textTransform: 'uppercase' }}>Controle Financeiro</div>
        </div>

        {erro && <p style={{ color: '#e74c3c', textAlign: 'center', marginBottom: 12, fontSize: 14 }}>{erro}</p>}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: '#6b7a8d', textTransform: 'uppercase', letterSpacing: 0.8, display: 'block', marginBottom: 6 }}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" required
              style={{ width: '100%', padding: '12px 14px', border: '1.5px solid #d4dde8', borderRadius: 8, fontSize: 15, boxSizing: 'border-box', outline: 'none', transition: 'border-color 0.2s' }}
              onFocus={e => e.target.style.borderColor = '#D85A30'} onBlur={e => e.target.style.borderColor = '#d4dde8'} />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: '#6b7a8d', textTransform: 'uppercase', letterSpacing: 0.8, display: 'block', marginBottom: 6 }}>Senha</label>
            <input type="password" value={senha} onChange={e => setSenha(e.target.value)} placeholder="••••••••" required
              style={{ width: '100%', padding: '12px 14px', border: '1.5px solid #d4dde8', borderRadius: 8, fontSize: 15, boxSizing: 'border-box', outline: 'none', transition: 'border-color 0.2s' }}
              onFocus={e => e.target.style.borderColor = '#D85A30'} onBlur={e => e.target.style.borderColor = '#d4dde8'} />
          </div>
          <button type="submit" disabled={carregando} style={{ width: '100%', padding: 14, background: carregando ? '#B84A24' : '#D85A30', color: 'white', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: carregando ? 'not-allowed' : 'pointer', transition: 'background 0.2s', letterSpacing: 0.5 }}
            onMouseEnter={e => { if (!carregando) e.target.style.background = '#B84A24'; }}
            onMouseLeave={e => { if (!carregando) e.target.style.background = '#D85A30'; }}>
            {carregando ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 11, color: '#C0C8D6', letterSpacing: 0.5 }}>
          Sobraa © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {mostrarCardAlertas && cofreAlertas.length > 0 && (
        <CardAlertasCofre
          alertas={cofreAlertas}
          onFechar={() => { setMostrarCardAlertas(false); setCofreAlertas([]); }}
          onIrCofre={() => setAba('cofre')}
        />
      )}
      <Layout
        usuario={usuario}
        onLogout={handleLogout}
        abas={abas}
        abaAtiva={aba}
        onAba={setAba}
        pushStatus={pushStatus}
        onAtivarPush={ativarNotificacoesPush}
        mostrarPush={temChatOuTickets}
      >
        {perfis.includes('func') && aba === 'reembolso'      && <Funcionario usuario={usuario} aba={aba} toast={showToast} />}
        {perfis.includes('fin')  && aba === 'pagamentos'     && <Financeiro toast={showToast} />}
        {perfis.includes('ges')  && aba === 'config'         && <Gestor aba={aba} toast={showToast} />}
        {perfis.includes('est')  && aba === 'estoque'        && <Estoque usuario={usuario} toast={showToast} />}
        {perfis.includes('fec')  && aba === 'fechamento'     && <Fechamento toast={showToast} />}
        {perfis.includes('orc')  && aba === 'orcamentos'     && <Orcamento toast={showToast} />}
        {perfis.includes('age')  && aba === 'agenda'         && <Agenda usuario={usuario} toast={showToast} />}
        {perfis.includes('tkt')  && modulos.includes('tkt')  && aba === 'tickets'       && <Tickets usuario={usuario} toast={showToast} />}
        {perfis.includes('cht')  && modulos.includes('cht')  && aba === 'chat'          && <Chat usuario={usuario} toast={showToast} />}
        {perfis.includes('cof')  && aba === 'cofre'          && <Cofre usuario={usuario} toast={showToast} />}
        {perfis.includes('ctr')  && modulos.includes('ctr')  && aba === 'contratos'     && <Contratos usuario={usuario} toast={showToast} />}
        {perfis.includes('rel')  && aba === 'relatorios'     && <Relatorios usuario={usuario} toast={showToast} modulos={modulos} />}
        {perfis.includes('mon')  && modulos.includes('mon') && aba === 'monitoramento'  && <Monitoramento toast={showToast} />}
      </Layout>
      <Toast msg={toast.msg} tipo={toast.tipo} />
    </>
  );
}
